export default __webpack_public_path__ + "static/media/database-security.1606b770.png";